export default __webpack_public_path__ + "static/media/hh-character-regular-neutral-idle.fe13ba4a.mp4";